import React from 'react'
import { BaasIllustrationBuble } from '../../svg/BaasIllustrationBuble'
import { registerRedirect } from '../../utils/router'
import { Button } from '../atoms/Button'

export const LastSection: React.FC = () => {
    return (
        <section className="snap-start h-screen flex items-center justify-center bg-neutral-900" aria-label="Get Started">
            <div className="max-w-screen-xl w-full mx-auto flex flex-col justify-center items-center">
                <div className="relative w-full h-full flex flex-col items-center justify-center">
                    {/* BaasIllustrationBubble container */}
                    <div className="absolute inset-0 flex items-center justify-center scale-90 sm:scale-150" aria-hidden="true">
                        <BaasIllustrationBuble />
                    </div>

                    {/* Text and button container */}
                    <div className="z-10 text-center">
                        <h2 className="font-sansCondensed sm:text-2xl lg:text-3xl xl:text-5xl font-black">
                            Instantly
                        </h2>
                        <p className="font-sansCondensed sm:text-xl lg:text-2xl xl:text-4xl font-black">
                            send your first bot.
                        </p>
                        <Button
                            flatbutton={false}
                            buttonClass="w-fit mx-auto cursor-pointer"
                            name="Get your key"
                            onClick={registerRedirect}
                            color="green"
                            textColor="text-neutral-900"
                            aria-label="Register and get your API key"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}